<template>
    <div class="px-0" style="min-height: 100%; display: flex;">
        <Sidebar v-if="this.isSidebarActive" :settings="this.allSettings" @menuOptionSelected="this.handleClickMenu"  />
        <Container :settings="this.allSettings" ref="containerComponent" @menuOptionSelected="this.handleClickMenu" :key="this.allSettings.container.currentKey" />
    </div>
</template>

<script>

import Sidebar  from "./refresh-application/Sidebar.vue";
import Container from "./refresh-application/Container.vue";
export default {
    name: 'RefreshApplication',
    props: {
        uid: {
            type: String,
            required: false,
        },
        leadData: {
            type: Object,
            required: false,
            default: {}
        },
    },
    components: {
        Sidebar,
        Container
    },
    data() {
        return {
            maskedPhoneNumber: this.leadData ? this.leadData.cell_phone : null,
            allSettings: {
                sidebar: {
                    isActive: false,
                    firstLoadWasAttempted: false,
                },
                container: {
                    currentKey: 0,
                    showOtherOffers: false,
                    title: null
                },
                isPhoneConfirmed: false,
                hasFailedPhoneConfirmation: false,
                phoneConfirmationMaxFailedAttempts: 3,
                selectedProduct: null,
                isMobile: true,
                newApplicationUrl: '/loan',
                memberPortalUrl: 'https://compare.loanscanada.ca/',
            }
        }
    },
    mounted() {
        console.log('RefreshApplication mounted');
        this.allSettings.isMobile = this.checkIfMobile();
        this.allSettings.sidebar.isActive = this.isSidebarActive;
    },
    methods: {
        checkIfMobile() {
            const isSmallScreen = window.innerWidth <= 820;
            const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            return isSmallScreen && isTouchDevice;
        },
        handleClickMenu(option) {
            console.log('Menu option clicked: ' + option);

            this.allSettings.container.title = null;
            // this is to close the mobile menu when a specific option is selected
            if(this.allSettings.isMobile) {
                this.handleToggleSidebar(false);
            }

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

            switch (option) {
                case 'product_selection':
                    this.allSettings.selectedProduct = null;
                    this.allSettings.container.showOtherOffers = false;
                    break;
                // case 'review_data':
                // default:
                //     break;
            }
        },
        handleToggleSidebar(status) {
            this.allSettings.sidebar.isActive = !!status;
        },
        setNewApplicationUrl() {
            let productNameRoutes = {
                'personal_loan' : 'loan',
                'car_loan' : 'car'
            };
            this.allSettings.newApplicationUrl = `/${productNameRoutes[this.allSettings.selectedProduct] ?? 'loan'}`;
        }
    },
    computed: {
        isSidebarActive() {
            return this.allSettings.isPhoneConfirmed && this.allSettings.sidebar.isActive;
        },
    },
    watch: {
        // "allSettings.selectedProduct": {
        //     // immediate: true,
        //     handler() {
        //         this.setNewApplicationUrl();
        //     }
        // },
    }
}
</script>

<style scoped>

</style>
